/**********************************************************************
// @@@ START COPYRIGHT @@@
//        AVI SOLAR ENERGY CONFIDENTIAL: NEED TO KNOW ONLY
//        Copyright 2018 - 2019
//        Avi Solar Energy Pvt Ltd.
//        Protected as an unpublished work.
//  The computer program listings, specifications and documentation
//  herein are the property of Avi Solar Energy Pvt Ltd., or a third party supplier
//  and shall not be reproduced, copied, disclosed, or used in whole or in part for
//  any reason without the prior express written permission of Avi Solar Energy Pvt Ltd.
// @@@ END COPYRIGHT @@@
// +++ Code modified on 2019/02/25
**********************************************************************/
<template>
  <Card>
    <Toolbar>
      <v-toolbar-title>{{ $t('Carbon Footprint (Today)') }}</v-toolbar-title>
      <v-spacer></v-spacer>
    </Toolbar>
    <v-layout row wrap class="card--height" align-center justify-center>
      <v-flex md6 v-for="card in cards" :key="card.title">
        <v-flex md12 text-xs-center flexbox>
          <img :src="require(`../../../assets/${card.img}`)" alt="battery" height="40px" width="40px">
          <div class="display-1">{{card.data}}<span class="caption">{{card.unit}}</span></div>
          <div class="body-2 font-weight-thin">{{card.title}}</div>
        </v-flex>
      </v-flex>
    </v-layout>
  </Card>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([
      'getTotalGeneration'
    ]),
    cards() {
      const todayCo2 = this.getTotalGeneration * 0.0008
      const todayDiesel = this.getTotalGeneration * 0.069
      const todayTreeSaved = this.getTotalGeneration * 0.012
      const todayHouseLighted = this.getTotalGeneration * 0.0001

      return [{
          title: this.$t('Tree Saplings Planted'),
          img: 'plant-tree.svg',
          data: todayTreeSaved.toFixed(3),
          unit: ' Nos',
          flex: 6
        },
        {
          title: this.$t('House Lighted'),
          img: 'idea.svg',
          data: todayHouseLighted.toFixed(3),
          unit: ' Nos',
          flex: 6
        },
        {
          title: this.$t('Diesel Consumption Reduced'),
          img: 'gasoline.svg',
          data: todayDiesel.toFixed(3),
          unit: ' Gallon',
          flex: 6
        },
        {
          title: this.$t('CO2 emission Reduced'),
          img: 'co2.svg',
          data: todayCo2.toFixed(3),
          unit: ' Tons',
          flex: 6
        }
      ]
    }
  }
}
</script>
<style scoped>
.card--height{
    height: calc(100vh - 269px);
}
</style>
